import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  BranchesApi,
  GetAllCategoriesAPI,
  GetBranchCategoriesAPI,
} from "../../ApiRequests";

export const fetchBranches = createAsyncThunk("fetch/branch", async () => {
  try {
    const response = await BranchesApi();
    if (!response.data?.success) {
      showErrorToast(response.data.error.msg);
    } else if (response.data?.success) {
      return response.data.data.payload;
    }
  } catch (error) {
    console.log(error);
  }
  return [];
});

const BranchesSlice = createSlice({
  name: "category-data",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBranches.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchBranches.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchBranches.rejected, (state, action) => {
      state.isError = true;
      console.log("Error: ", action.error);
    });
  },
});

export default BranchesSlice.reducer;
